import React from "react";
import TypingText from "./TypingText";
import { Terminal, Github, Linkedin } from "lucide-react";
import profile_pic from "../images/profile_pic.jpg";

const Hero = () => {
  const roles = [
    "Penetration Tester",
    "Red Team Operator",
    "Security Auditor",
    "Exploit Developer",
    "Offensive Security Specialist",
  ];

  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden gradient-hero cyber-grid">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/50 to-background pointer-events-none" />

      {/* Animated circles */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-float" />
      <div
        className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-secondary/5 rounded-full blur-3xl animate-float"
        style={{ animationDelay: "1s" }}
      />

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Profile Image */}
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary via-secondary to-primary rounded-full blur-md opacity-50 group-hover:opacity-75 transition duration-500 animate-pulse" />
            <div className="relative w-64 h-64 lg:w-80 lg:h-80 rounded-full overflow-hidden border-2 border-primary/50 glow top-margin-80">
              <img
                src={profile_pic}
                alt="Omar Totangy"
                className="w-full h-full object-cover object-position-top"
              />
              {/* Scanline overlay */}
              <div className="absolute inset-0 scanlines" />
            </div>
          </div>

          {/* Text Content */}
          <div className="text-center lg:text-left max-w-2xl">
            <div className="font-mono text-sm text-primary mb-4 flex items-center justify-center lg:justify-start gap-2">
              <Terminal className="w-4 h-4" />
              <span>root@tunchi:~$ whoami</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold mb-4 tracking-tight">
              <span className="text-foreground">Omar </span>
              <span className="text-primary text-glow glitch">Totangy</span>
            </h1>

            <div className="h-12 mb-6">
              <TypingText
                texts={roles}
                className="text-xl lg:text-2xl font-mono text-muted-foreground"
              />
            </div>

            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Cybersecurity specialist with expertise in offensive security,
              penetration testing, and red team operations. Passionate about
              finding vulnerabilities before the bad actors do.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 margin-bottom-5 justify-center lg:justify-start">
              <a
                href="https://github.com/omaritgis"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 mx-5 px-6 py-3 border border-border hover:border-primary bg-card/50 rounded-lg hover-lift transition-all"
              >
                <Github className="w-5 h-5" />
                <span>GitHub</span>
              </a>

              <a
                href="https://linkedin.com/in/omartotangy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-6 py-3 border border-border hover:border-primary bg-card/50 rounded-lg hover-lift transition-all"
              >
                <Linkedin className="w-5 h-5" />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
